import { render } from "./bidangInfrastruktur.vue?vue&type=template&id=0783393f"
import script from "./bidangInfrastruktur.vue?vue&type=script&lang=js"
export * from "./bidangInfrastruktur.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__